/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyNano = createReactComponent("outline", "currency-nano", "IconCurrencyNano", [["path", { "d": "M7 20l10 -16", "key": "svg-0" }], ["path", { "d": "M7 12h10", "key": "svg-1" }], ["path", { "d": "M7 16h10", "key": "svg-2" }], ["path", { "d": "M17 20l-10 -16", "key": "svg-3" }]]);

export { IconCurrencyNano as default };
//# sourceMappingURL=IconCurrencyNano.mjs.map
